import { trendingArticles } from '@/mocks/zh/article';

export default function TrendingGrid() {
  return (
    <section id="trending" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 gap-3">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              热门推荐
            </h2>
            <p className="text-sm text-foreground-500 mt-2">全网热议的独家爆料</p>
          </div>
          <p className="text-sm text-foreground-400 max-w-md leading-relaxed">
            精选今日最受关注的爆料内容，为你呈现最劲爆的吃瓜体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {trendingArticles.map((article, index) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200 hover:border-accent-300 transition-all duration-300"
            >
              <div className="relative w-full h-52 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className={`px-2.5 py-1 text-xs font-semibold rounded-full ${
                    index === 1
                      ? 'bg-accent-500 text-foreground-950'
                      : 'bg-accent-100/80 text-accent-800'
                  }`}>
                    {article.categoryName}
                  </span>
                </div>
              </div>
              <div className="p-5">
                <h3 className="text-base font-semibold text-foreground-900 leading-snug line-clamp-2 mb-3 group-hover:text-accent-700 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2 mb-4">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center gap-3 text-xs text-foreground-400">
                    <span><i className="ri-calendar-line mr-1"></i>{article.date}</span>
                    <span><i className="ri-eye-line mr-1"></i>
                      {article.views >= 10000
                        ? `${(article.views / 10000).toFixed(0)}万`
                        : article.views}
                    </span>
                  </div>
                  <span className="text-xs font-medium text-accent-600 whitespace-nowrap group-hover:translate-x-1 transition-transform inline-flex items-center gap-0.5">
                    阅读全文 <i className="ri-arrow-right-s-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-10 text-center">
          <Link
            to="/category/live-gossip"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-100 text-foreground-700 font-medium rounded-full text-sm hover:bg-background-200 transition-colors"
          >
            查看更多爆料 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}